module.exports = __webpack_public_path__ + "static/media/3-3-3.d43a1a42.png";